import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import axios from 'axios';
import React from 'react';
import { Container, Col, Row, Image, Form } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { NavLink, useHistory } from 'react-router-dom';
import swal from 'sweetalert';
import ReCAPTCHA from 'react-google-recaptcha';
import '../../../Assets/css/mjstatic.css';
import customImg1 from '../../../Assets/images/img_one.png';
import customImg2 from '../../../Assets/images/img_two.png';
import customImg3 from '../../../Assets/images/img_three.webp';
import { base_url } from '../../../Helpers/request';
import { useSelector } from 'react-redux';

const CustomDesigns = () => {
  const history = useHistory();
  const [chooseType, setChooseType] = React.useState('');
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [mobile, setMobile] = React.useState('');
  const [budget, setBudget] = React.useState('');
  const [capchaloading, setCapchaLoading] = React.useState(true);
  const [notes, setNotes] = React.useState('');
  const [material, setMaterial] = React.useState('');
  const [image, setImage] = React.useState(null);
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);

  const onChange = (value) => {
    if (value) {
      setCapchaLoading(false);
    }
  };

  const handleChangeChooseType = (event) => {
    setChooseType(event.target.value);
  };
  const handleChangeMaterial = (event) => {
    setMaterial(event.target.value);
  };
  const postform = (e) => {
    e.preventDefault();
    var data = {
      name,
      email,
      mobile,
      budget,
      notes,
      material,
      image,
    };

    let formData = new FormData();
    formData.append('type', chooseType);
    formData.append('name', name);
    formData.append('email', email);
    formData.append('mobile', mobile);
    formData.append('budget', budget);
    formData.append('material', material);
    formData.append('note', notes);
    formData.append('file', image);
    const config = {
      headers: { 'content-type': 'multipart/form-data' },
    };
    axios
      .post(base_url + '/common/customProductRequest', formData, config)
      .then((response) => {
        if (response.data.status == 1) {
          swal(response.data.message, '', 'success');
        } else {
          swal(response.data.message, '', 'error');
        }
        setName('');
        setEmail('');
        setMobile('');
        setBudget('');
        setNotes('');
        setMaterial('');
        setImage('');
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails?.title}</title>
        <meta name="description" content={metaDetails?.description}></meta>
        <meta name="keywords" content={metaDetails?.keywords}></meta>
      </Helmet>
      <div className="rcs_customDesgin_banner">
        <Container>
          <h2 className="dfl_custom_h2 position-relative fs40 color-dark">
            {' '}
            <div className="fs20">Locally made and</div> handcrafted{' '}
          </h2>
        </Container>
      </div>
      <div className="rcs_new_custome_page">
        <Container className="pt-4 pb-4">
          <Row>
            <Col sm={12} md={12} lg={12}>
              <div className="mt-4 pb-5">
                <h1 className="text-uppercase mb-4 font-bolder dfl_custome_font_inter">Custom Jewellery Toronto</h1>
                <p>
                For over 50 years, Diamonds For Less has been creating custom-made diamond Jewellery in Toronto. 
                We understand that it's a meticulous and detailed process that demands a high level of skill, craftsmanship, and experience. 
                Our diamond experts use both state of the art technologies and century-old techniques to create each piece by hand, ensuring that each custom piece is unique and one-of-a-kind. The design is customized to reflect your individual style and personality,
                 whether it's   <NavLink to="/engagement-rings-toronto" className="text-dark text-decoration-none">
                 <strong>an engagement rings </strong> 
                 </NavLink> or any <NavLink to="/jewellery" className="text-dark text-decoration-none">
                 <strong>  other diamond jewellery </strong> </NavLink> Custom Jewellery is a timeless and treasured expression of love and beauty.
                </p>
                <p>
                At Diamonds For Less, we specialise in creating exquisite <strong>custom engagement rings in Toronto</strong>   that perfectly reflect your love story. Our team works closely with you to design a ring that captures your unique vision, incorporating your preferred gemstones and metals to form the ring of your dreams. Whether you prefer a classic round diamond solitaire or a modern twist on a timeless design, 
                we ensure each piece is a stunning representation of your style as well as your love story.
                 </p>
                 <p>While our readymade rings are designed to last, choosing <strong>custom jewellery in Toronto</strong> allows you to express and relive your style and preferences, making every piece truly one-of-a-kind. 
                 Our design process is not just about creating a piece of jewellery; it's about understanding your 
                 vision and bringing it to life. We take the time to understand your requirements and create a meticulously
                  inclined piece of jewellery, from the initial sketch to the final polish. We know your 
                  jewellery is more than a mere accessory; it's a cherished memory. 
                  By offering these bespoke solutions, we enable you to create a meaningful piece 
                  of jewellery that resonates with your individual taste and style while adequately
                   representing your special moments.
                 </p>
                 <p> 
                  As <strong> Toronto custom jewellers </strong> , we pride ourselves on our commitment to quality and 
                  craftsmanship. We are dedicated to making your custom design experience at Diamonds For Less 
                  as personalised and remarkable as possible. Our team is also here to guide you throughout the
                   design process, from picking out the finest materials for your custom creation to ensuring it 
                   turns out beautiful and durable—our vast selection of diamonds, ring styles, and metals allows
                    you to bring your dream jewellery to life, tailored to your specifications and budget.
                 </p>
                 <p>When it comes to  <NavLink to="/engagement-rings-toronto" className="text-dark text-decoration-none">
                    <strong> engagement rings in Toronto </strong> , Diamonds For Less is your trusted partner in crafting exceptional, custom pieces. 
                    Our focus on customer satisfaction lets us prioritise your needs and desires, ensuring you leave our store with a ring that exceeds your expectations. Experience the joy of designing your dream ring with us and celebrate your love with the one that resonates with your story.
                  </NavLink>
                 </p> <p>Book a no obligation appointment  <NavLink to="/make-an-appointment" className="text-dark text-decoration-none">
                 <strong><u>VISIT US</u></strong></NavLink> , meet with one of our diamond experts and see what DFL can do for you.</p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={4}>
              <div className="rcs_customDesgin_content">
                <Image src={customImg1} alt="Ideas-image"></Image>
                <div className="rcs_customDesgin_content rcs_customDesgin_content1 mt-4 pb-3">
                  <h3>Tell Us Your Ideas</h3>
                  <p>Share pictures, inspo Pinterest boards or any other ideas you have gathered. Our experienced designers will guide you through every step, provide tailored suggestions, recommendations, and discuss with you the best possible options available.</p>
                </div>
              </div>
            </Col>
            <Col xs={12} sm={12} md={4}>
              <div className="rcs_customDesgin_content">
                <Image src={customImg2} alt="Production-image"></Image>
                <div className="rcs_customDesgin_content rcs_customDesgin_content1 mt-4 pb-3">
                  <h3>Design & Production</h3>
                  <p>The DFL team comprises highly skilled designers, diamond experts. Throughout the process, a DFL representative will share with you realistic 3D renderings and progress reports. This way, you can visualize your custom piece and make any necessary adjustments along the way. We work closely with you to ensure that your bespoke creation is flawless and embodies your vision.</p>
                </div>
              </div>
            </Col>
            <Col xs={12} sm={12} md={4}>
              <div className="rcs_customDesgin_content">
                <Image src={customImg3} alt="Completion-image"></Image>
                <div className="rcs_customDesgin_content rcs_customDesgin_content1 mt-4 pb-3">
                  <h3>Completion</h3>
                  <p>We handcraft your custom engagement ring in Toronto and provide you with an opportunity to inspect and approve the final creation. We expect nothing but perfection and your complete satisfaction for all our custom engagement rings and diamond jewellery in Toronto.</p>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12}>
              <div className="mt-5">
                <h3 className="mb-0 dfl_custome_font_inter">ENJOY & ADMIRE YOUR ONE-OF-A-KIND CUSTOM JEWELLERY</h3>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="rcs_new_custome_page_form rcs_account_content_left mt-3 mb-5">
        <Container>
          <Row className="m-auto w-100">
            <Col xs={12}>
              <h4 className="mb-5 dfl_custome_font_inter text-center">LET'S START YOUR PROJECT!</h4>
            </Col>
          </Row>
          <Form onSubmit={postform}>
            <Row className="m-auto w-100">
              <Col md={6}>
                <FormControl fullWidth>
                  <InputLabel id="rcs_choose_type">Choose Type</InputLabel>
                  <Select labelId="rcs_choose_type" id="demo-simple-select" value={chooseType} label="Choose Type" onChange={handleChangeChooseType} required>
                    <MenuItem value="Bracelet">Bracelet</MenuItem>
                    <MenuItem value="Chain">Chain</MenuItem>
                    <MenuItem value="Pendant">Pendant</MenuItem>
                    <MenuItem value="Ring">Ring</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                    <MenuItem value="Necklace ">Necklace </MenuItem>
                  </Select>
                </FormControl>
              </Col>
              <Col md={6}>
                <TextField id="outlined-basic" label="Name" type="text" value={name} onChange={(e) => setName(e.target.value)} required variant="outlined"></TextField>
              </Col>
              <Col md={6}>
                <TextField id="outlined-basic" label="Email Address" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required variant="outlined"></TextField>
              </Col>
              <Col md={6}>
                <TextField id="outlined-basic" label="Mobile Number" type="number" value={mobile} onChange={(e) => setMobile(e.target.value)} required variant="outlined"></TextField>
              </Col>
              <Col md={6}>
                <TextField id="outlined-basic" label="Total Budget" type="number" value={budget} onChange={(e) => setBudget(e.target.value)} required variant="outlined"></TextField>
              </Col>
              <Col md={6}>
                <FormControl fullWidth>
                  <InputLabel id="rcs_metal_type">Metal Type</InputLabel>
                  <Select labelId="rcs_metal_type" id="demo-simple-select" value={material} label="Material" onChange={handleChangeMaterial}>
                    <MenuItem value="10k Gold">10k Gold</MenuItem>
                    <MenuItem value="14k Gold">14k Gold</MenuItem>
                    <MenuItem value="18k Gold">18k Gold</MenuItem>
                    <MenuItem value="22k Gold">22k Gold</MenuItem>
                    <MenuItem value="24 Gold">24k Gold</MenuItem>
                    <MenuItem value="Platinum">Platinum</MenuItem>
                  </Select>
                </FormControl>
              </Col>
              <Col md={6}>
                <TextField
                  id="filled-multiline-static"
                  label="Notes"
                  type="text"
                  multiline
                  InputLabelProps={{
                    shrink: true,
                  }}
                  rows={4}
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  placeholder="Please describe your idea for this Custom Project and provide us with as many details as you can, so we can get back to you with a quote for your Custom Jewellery."
                  variant="outlined"
                ></TextField>
              </Col>
              <Col md={6}>
                <TextField
                  id="outlined-basic"
                  label="Upload"
                  type="file"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => setImage(e.target.files[0])}
                  helperText="Choose your file here to upload. Allowed type(pdf,jpg,png,jpeg,doc,docx)"
                ></TextField>
              </Col>
              <Col md={6}>
                <ReCAPTCHA sitekey="6Lc6LUscAAAAAKO2DYPGrIPSnwx3fzROCxJzNWQ0" onChange={onChange} onExpired={() => setCapchaLoading(true)} />
              </Col>
              <Col xs={12} className="mt-3">
                <Button disabled={capchaloading ? true : false} variant="contained" type="submit" className="rcs_acc_button rcs_review_btn">
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </Container>
      </div>
    </div>
  );
};

export default CustomDesigns;
